module.exports = "<div class=\"app\">\n    <st-global-preloader></st-global-preloader>\n    <div ui-view=\"navbar\"></div>\n    <div ui-view=\"main\" class=\"p-sticky__content\"></div>\n    <div ui-view=\"footer\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 170
// module chunks = 0